import PropTypes from 'prop-types';

export const PdxPatientType = PropTypes.shape({
    ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    FirstName: PropTypes.string,
    MiddleName: PropTypes.string,
    LastName: PropTypes.string,
    ExternalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Email: PropTypes.string,
    AddressLine1: PropTypes.string,
    AddressLine2: PropTypes.string,
    City: PropTypes.string,
    State: PropTypes.string,
    Zip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    HomePhone: PropTypes.string,
    MobilePhone: PropTypes.string,
    BirthDate: PropTypes.string,
    MaritalStatus: PropTypes.string,
    Linked: PropTypes.bool,
    Gender: PropTypes.string,
    OtherMedication: PropTypes.arrayOf(PropTypes.string),
    Diagnosis: PropTypes.shape({
        diagnosis: PropTypes.string,
        icd9: PropTypes.string,
    }),
    Allergies: PropTypes.arrayOf(PropTypes.string),
    Pdx: PropTypes.shape({
        rxcom_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
});
